import React from 'react';
import { Header } from './Header';
import { HeroSection } from './HeroSection';
import { ServicesSection } from './ServicesSection';
import { ProofSection } from './ProofSection';
import { ContactSection } from './ContactSection';
import { Footer } from './Footer';

export const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <ServicesSection />
      <ProofSection />
      <ContactSection />
      <Footer />
    </div>
  );
};